<template>
    <div class="mt-[80px]" id="reviews">
        <div class="flex justify-between">
            <h2 class="text-[18px] md:text-[24px] font-semibold mb-[24px]">Reviews</h2>

            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="124" height="24" viewBox="0 0 124 24" fill="none">
                    <mask id="mask0_99_2020" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                        height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_99_2020)">
                        <path
                            d="M5.825 22L7.45 14.975L2 10.25L9.2 9.625L12 3L14.8 9.625L22 10.25L16.55 14.975L18.175 22L12 18.275L5.825 22Z"
                            fill="#262626" />
                    </g>
                    <mask id="mask1_99_2020" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="25" y="0" width="24"
                        height="24">
                        <rect x="25" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask1_99_2020)">
                        <path
                            d="M30.825 22L32.45 14.975L27 10.25L34.2 9.625L37 3L39.8 9.625L47 10.25L41.55 14.975L43.175 22L37 18.275L30.825 22Z"
                            fill="#262626" />
                    </g>
                    <mask id="mask2_99_2020" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="50" y="0" width="24"
                        height="24">
                        <rect x="50" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask2_99_2020)">
                        <path
                            d="M55.825 22L57.45 14.975L52 10.25L59.2 9.625L62 3L64.8 9.625L72 10.25L66.55 14.975L68.175 22L62 18.275L55.825 22Z"
                            fill="#262626" />
                    </g>
                    <mask id="mask3_99_2020" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="75" y="0" width="24"
                        height="24">
                        <rect x="75" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask3_99_2020)">
                        <path
                            d="M80.825 22L82.45 14.975L77 10.25L84.2 9.625L87 3L89.8 9.625L97 10.25L91.55 14.975L93.175 22L87 18.275L80.825 22Z"
                            fill="#262626" />
                    </g>
                    <mask id="mask4_99_2020" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="100" y="0" width="24"
                        height="24">
                        <rect x="100" width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask4_99_2020)">
                        <path
                            d="M105.825 22L107.45 14.975L102 10.25L109.2 9.625L112 3L114.8 9.625L122 10.25L116.55 14.975L118.175 22L112 18.275L105.825 22Z"
                            fill="#262626" />
                    </g>
                </svg>
            </div>
        </div>

        <div>
            <div v-if="user" class="rounded-xl py-[20px] px-[24px] bg-[#EEF1F6]">
                <textarea v-model="newReviewText"
                    class="border border-[#CDD5E3] p-[15px] rounded-xl bg-white block w-full" rows="4"
                    placeholder="Write a review"></textarea>

                <button @click="addReview()"
                    class="bg-primary-500 text-contrast-500 font-[500] flex justify-center items-center rounded-xl py-2 px-[20px] hover:shadow duration-100 hover:bg-primary-400 h-[40px] mt-[20px] w-[137px] max-w-full"
                    type="submit">
                    Publish
                </button>
            </div>

            <div class="flex flex-col justify-center items-center mt-[40px]">
                <div v-for="review in reviews" class="max-w-[887px] flex space-x-[15px] items-start w-full mt-4">
                    <img :src="review.user_avatar_url" width="50" height="50" class="rounded-full" alt="Avatar"/>

                    <div class="space-y-[8px]">
                        <h5 class="text-lg font-medium">{{ review.user_name }}</h5>

                        <svg xmlns="http://www.w3.org/2000/svg" width="124" height="24" viewBox="0 0 124 24"
                            fill="none">
                            <mask id="mask0_99_2041" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_99_2041)">
                                <path
                                    d="M5.825 22L7.45 14.975L2 10.25L9.2 9.625L12 3L14.8 9.625L22 10.25L16.55 14.975L18.175 22L12 18.275L5.825 22Z"
                                    fill="#262626" />
                            </g>
                            <mask id="mask1_99_2041" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="25" y="0"
                                width="24" height="24">
                                <rect x="25" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask1_99_2041)">
                                <path
                                    d="M30.825 22L32.45 14.975L27 10.25L34.2 9.625L37 3L39.8 9.625L47 10.25L41.55 14.975L43.175 22L37 18.275L30.825 22Z"
                                    fill="#262626" />
                            </g>
                            <mask id="mask2_99_2041" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="50" y="0"
                                width="24" height="24">
                                <rect x="50" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask2_99_2041)">
                                <path
                                    d="M55.825 22L57.45 14.975L52 10.25L59.2 9.625L62 3L64.8 9.625L72 10.25L66.55 14.975L68.175 22L62 18.275L55.825 22Z"
                                    fill="#262626" />
                            </g>
                            <mask id="mask3_99_2041" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="75" y="0"
                                width="24" height="24">
                                <rect x="75" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask3_99_2041)">
                                <path
                                    d="M80.825 22L82.45 14.975L77 10.25L84.2 9.625L87 3L89.8 9.625L97 10.25L91.55 14.975L93.175 22L87 18.275L80.825 22Z"
                                    fill="#262626" />
                            </g>
                            <mask id="mask4_99_2041" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="100" y="0"
                                width="24" height="24">
                                <rect x="100" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask4_99_2041)">
                                <path
                                    d="M105.825 22L107.45 14.975L102 10.25L109.2 9.625L112 3L114.8 9.625L122 10.25L116.55 14.975L118.175 22L112 18.275L105.825 22Z"
                                    fill="#262626" />
                            </g>
                        </svg>

                        <div v-html="review.body" class="text-lg">

                        </div>

                        <div class="text-sm">{{ review.created_at_for_humans }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import { usePage } from '@inertiajs/vue3'


export default {
    props: {
        teachingMaterial: Object
    },
    data() {
        return {
            newReviewText: null,
            reviews: this.teachingMaterial.reviews ?? []
        }
    },
    methods: {
        async addReview() {
            try {
                let data = await Axios.post(route('api.reviews.store'), {
                    body: this.newReviewText,
                    teachingMaterialId: this.teachingMaterial.id
                }).then(resp => resp.data)

                this.reviews.push({
                    'user_name': this.user?.name,
                    'user_avatar_url': this.user?.avatar_url,
                    'body': this.newReviewText,
                    'created_at_for_humans': 'Just now'
                })
                this.newReviewText = ''
            }
            catch (e) {
                console.error(e)
            }
            finally {

            }
        }
    },
    computed: {
        user() {
            return usePage().props.auth.user;
        },
    },
    mounted() {
        console.log('user', this.user)
    }
}
</script>
